module.exports = __webpack_public_path__ + "static/media/Tile Sero.743d9937.jpg";